import { useCallback, useMemo } from 'react';
import i18n from 'i18n-js';

import { DEFAULT_ROLE, ROLE_OPTIONS } from '@components/tenantStatus/onboardingWizard/constants';
import type { TeamMemberDraft, TeamStepProps } from '@components/tenantStatus/onboardingWizard/types';

export type UseManageTeamStepParams = Pick<TeamStepProps, 'data' | 'onChange'>;

export const useManageTeamStep = ({ data, onChange }: UseManageTeamStepParams) => {
  const handleRowChange = useCallback(
    (index: number, patch: Partial<TeamMemberDraft>) => {
      const next = data.members.map((m, i) => (i === index ? { ...m, ...patch } : m));
      onChange({ members: next });
    },
    [data.members, onChange]
  );

  const handleAdd = useCallback(() => {
    onChange({ members: [...data.members, { email: '', role: DEFAULT_ROLE }] });
  }, [data.members, onChange]);

  const roleItems = useMemo(() => ROLE_OPTIONS.map((role) => ({ label: i18n.t(role), value: role })), []);

  return { handleRowChange, handleAdd, roleItems };
};
